import type { MoversQuery } from '@/schemas/movers'
import type { TableQuery } from '@/schemas/table'

/**
 * Query key factory.
 *
 * The table key carries the whole query object — view, page, page size and the
 * three filters — because every one of them changes which rows come back. A
 * key built from `view` alone would serve page 4 of Gainers when the member
 * asked for page 1 of Losers, and React Query would have no way to know.
 *
 * `brokers` is the Brokers tab's own table, keyed on its page and sort the same way.
 */
export const moversKeys = {
  all: ['movers'] as const,
  tables: () => [...moversKeys.all, 'table'] as const,
  table: (query: MoversQuery) => [...moversKeys.tables(), query] as const,
  brokers: (query: TableQuery) => [...moversKeys.all, 'brokers', query] as const,
}
